export enum PERMISSIONS {
  APPEAL_ACTION_CREATE = 'APPEAL_ACTION.Create',
  APPEAL_ACTION_EDIT = 'APPEAL_ACTION.Edit',
  APPEAL_EDIT_INTERNAL_EDIT = 'APPEAL_EDIT_INTERNAL.Edit',
  APPEAL_EDIT_INTERNAL_CREATE = 'APPEAL_EDIT_INTERNAL.Create',
  APPEAL_EDIT_INTERNAL_READ = 'APPEAL_EDIT_INTERNAL.Read',

  APPEAL_QUEUE_READ = 'APPEAL_QUEUE.Read',
  APPEAL_ADVANCED_SEARCH_CREATE = 'APPEAL_ADVANCED_SEARCH.Create',
  APPEAL_ADVANCED_SEARCH_READ = 'APPEAL_ADVANCED_SEARCH.Read',
  APPEAL_RESPONSE_CREATE = 'APPEAL_RESPONSE.Create',
  APPEAL_RESPONSE_EDIT = 'APPEAL_RESPONSE.Edit',
  APPEAL_RESPONSE_READ = 'APPEAL_RESPONSE.Read',

  ACTIVITY_LOG_READ = 'ACTIVITY_LOG.Read',
  ACTIVITY_LOG_CREATE = 'ACTIVITY_LOG.Create',

  APPEAL_NOTE_DELETE = 'APPEAL_NOTE.Delete',
  CLAIM_SEARCH_VIEW_READ = 'CLAIM_SEARCH_VIEW.Read',
  CLAIM_ACTION_READ = 'CLAIM_ACTION.Read',
  CLAIM_ACTION_CREATE = 'CLAIM_ACTION.Create',
  CLAIM_ACTION_EDIT = 'CLAIM_ACTION.Edit',

  CLAIM_ATTACHMENT_READ = 'CLAIM_ATTACHMENT.Read',
  CLAIM_ATTACHMENT_CREATE = 'CLAIM_ATTACHMENT.Create',
  CLAIM_ATTACHMENT_DELETE = 'CLAIM_ATTACHMENT.Delete',
  CLAIM_ATTACHMENT_EXTERNAL_READ = 'CLAIM_ATTACHMENT_EXTERNAL.Read',
  CLAIM_ADVANCED_SEARCH_CREATE = 'CLAIM_ADVANCED_SEARCH.Create',

  CLAIM_ROUTING_READ = 'CLAIM_ROUTING.Read',
  CLAIM_ROUTING_CREATE = 'CLAIM_ROUTING.Create',
  CLAIM_NOTE_CREATE = 'CLAIM_NOTE.Create',
  CLAIM_NOTE_READ = 'CLAIM_NOTE.Read',
  DOCUMENT_CREATE = 'DOCUMENT.Create',
  DOCUMENT_DELETE = 'DOCUMENT.Delete',
  DOCUMENT_READ = 'DOCUMENT.Read',
  INVOICING_CREATE = 'INVOICING.Create',
  INVOICING_EDIT = 'INVOICING.Edit',
  INVOICING_READ = 'INVOICING.Read',
  INVOICING_DELETE = 'INVOICING.Delete',

  RULE_SPEC_CREATE = 'RULE_SPEC.Create',
  RULE_SPEC_EDIT = 'RULE_SPEC.Edit',
  RULE_SPEC_READ = 'RULE_SPEC.Read',

  INQUIRY_ASSIGNTO_CREATE = 'INQUIRY_ASSIGNTO.Create',
  INQUIRY_ACTION_EDIT = 'INQUIRY_ACTION.Edit',
  INQUIRY_ACTION_CLOSE_EDIT = 'INQUIRY_ACTION_CLOSE.Edit',

  CLIENT_ADMIN_CREATE = 'CLIENT_ADMIN.Create',
  CLIENT_ADMIN_EDIT = 'CLIENT_ADMIN.Edit',
  CLIENT_ADMIN_READ = 'CLIENT_ADMIN.Read',

  HELP_AND_SUPPORT_READ = 'HELP_AND_SUPPORT.Read',
}

export enum ROLES {
  ADMIN_USER = 'admin_user',
  STANDARD_USER = 'standard_user',
  PROD_USER = 'prod_user',
  INVOICE_READ_ONLY = 'invoice_read_only',
  INVOICE_MANAGER = 'invoice_manager',
  INVOICE_ADMIN = 'invoice_admin',}
